import { render } from "./ArtistItem.vue?vue&type=template&id=690aaf0a&scoped=true"
import script from "./ArtistItem.vue?vue&type=script&lang=js"
export * from "./ArtistItem.vue?vue&type=script&lang=js"

import "./ArtistItem.vue?vue&type=style&index=0&id=690aaf0a&scoped=true&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690aaf0a"]])

export default __exports__